import { RootState } from '../../rootReducer';

export const tagsSelectors = {
  getTags: (state: RootState) => state.TagsState.tags,
};
